import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
export type AssignmentGradingCountsFragment = { __typename?: 'Assignment', countOfSubmittedManuallyGradedGuesses: number, countOfUngradedGuesses: number, countOfGradingInProgressGuesses: number, countOfReleasableGradedGuesses: number, countOfCompletedStudents: number, countOfIncompleteStudents: number, countOfStudentsAwaitingGrade: number };

export type AssignmentReleaseStateFragment = { __typename?: 'Assignment', classroomAssignments: Array<{ __typename?: 'ClassroomAssignment', id: string, classroomId: string, gradesReleased?: boolean | null, gradesReleasedAt?: any | null, containsManuallyGradedQuestions?: boolean | null, settings: { __typename?: 'ClassroomAssignmentSettings', correctAnswerSetting: string, dueDate?: any | null } }> };

export const AssignmentGradingCountsFragmentDoc = gql`
    fragment AssignmentGradingCounts on Assignment {
  countOfSubmittedManuallyGradedGuesses(classroomIds: $classroomIds)
  countOfUngradedGuesses(classroomIds: $classroomIds)
  countOfGradingInProgressGuesses(classroomIds: $classroomIds)
  countOfReleasableGradedGuesses(classroomIds: $classroomIds)
  countOfCompletedStudents(classroomIds: $classroomIds)
  countOfIncompleteStudents(classroomIds: $classroomIds)
  countOfStudentsAwaitingGrade(classroomIds: $classroomIds)
}
    `;
export const AssignmentReleaseStateFragmentDoc = gql`
    fragment AssignmentReleaseState on Assignment {
  classroomAssignments {
    id
    classroomId
    gradesReleased
    gradesReleasedAt
    containsManuallyGradedQuestions
    settings {
      correctAnswerSetting
      dueDate
    }
  }
}
    `;